import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "label"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "rl-color-gray3"
};
const _hoisted_4 = {
  class: "rl-text-body-1 rl-fontweight-medium"
};
const _hoisted_5 = {
  class: "rl-text-body-4 rl-fontweight-lighter"
};
const _hoisted_6 = ["xlink:href"];
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  key: 0,
  viewBox: "0 0 34 34"
};
const _hoisted_9 = ["xlink:href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_intersectionObserver = _resolveDirective("intersectionObserver");
  return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent($props.groupInfo.type === $setup.itemTypeEnum.LINK ? 'a' : 'router-link'), {
    href: $props.groupInfo.type === $setup.itemTypeEnum.LINK ? $props.groupInfo.link : undefined,
    to: $props.groupInfo.type === $setup.itemTypeEnum.GROUP ? ($props.langPath ? $props.langPath : '/') + $props.groupInfo.category.join('/').toLowerCase() + '/' + $props.groupInfo.urlName : null,
    style: _normalizeStyle({
      'background-image': $props.groupInfo.thumbnail ? `url(${$props.groupInfo.thumbnail})` : 'none'
    }),
    class: _normalizeClass([{
      'has-thumbnail': $props.groupInfo.thumbnail,
      'has-externa-link': $setup.hasExternalLink
    }, "group-card"]),
    target: $setup.hasExternalLink ? '_blank' : '_self',
    rel: $setup.hasExternalLink ? 'noreferrer noopener' : null,
    onClick: _cache[0] || (_cache[0] = $event => $props.clickCardHandler($props.groupInfo, $props.position))
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["content", {
        'instructor': $props.groupInfo.instructor
      }])
    }, [$props.groupInfo.label ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "label",
      style: _normalizeStyle({
        backgroundColor: $props.groupInfo.label.color
      })
    }, _toDisplayString($props.groupInfo.label.name), 5)) : $props.groupInfo.isNew ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t("COMMON.NEW")), 1)) : _createCommentVNode("", true), $props.groupInfo.instructor ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [_createElementVNode("div", null, [_createElementVNode("img", {
      src: $setup.instructorsThumbnailUrl + $props.groupInfo.instructor.thumbnail
    }, null, 8, _hoisted_2)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString($props.groupInfo.instructor.name), 1), _createElementVNode("p", _hoisted_5, _toDisplayString($props.groupInfo.instructor.title), 1), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.groupInfo.instructor.software, software => {
      return _openBlock(), _createElementBlock("svg", {
        key: software,
        viewBox: "0 0 34 34"
      }, [_createElementVNode("use", {
        "xlink:href": $setup.iconIdTable[software]
      }, null, 8, _hoisted_6)]);
    }), 128))])])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 3
    }, [_createElementVNode("div", _hoisted_7, _toDisplayString($props.groupInfo.title), 1), $setup.hasExternalLink ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [_createElementVNode("use", {
      "xlink:href": $setup.isMagazine($props.groupInfo.link) ? '#Magazine' : '#link-out'
    }, null, 8, _hoisted_9)])) : _createCommentVNode("", true)], 64))], 2)]),
    _: 1
  }, 8, ["href", "to", "style", "class", "target", "rel"])), [[_directive_intersectionObserver, () => $props.impressionHandler($props.groupInfo, $props.position)]]);
}